/**
 * Vérifie si l'utilisateur est encore dans sa période d'essai gratuite.
 * Utilise date_fin_periode_gratuit (fin de la période d'essai stockée en base)
 * ou un fallback sur 7 jours depuis created_at.
 */
export const isInFreeTrial = (user) => {
  if (!user) return false

  // Priorité : date de fin de période gratuite explicite
  if (user.date_fin_periode_gratuit) {
    const endDate = new Date(user.date_fin_periode_gratuit)
    return new Date() <= endDate
  }

  // Fallback : 7 jours depuis la création du compte
  const createdAt = user.created_at || user.date_creation
  if (createdAt) {
    const daysSince = (Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24)
    return daysSince <= 7
  }

  return false
}

/**
 * Retourne le nombre de jours restants dans la période d'essai (0 si expirée).
 */
export const getFreeTrialDaysLeft = (user) => {
  if (!user) return 0

  if (user.date_fin_periode_gratuit) {
    const diff = new Date(user.date_fin_periode_gratuit) - new Date()
    return Math.max(0, Math.ceil(diff / (1000 * 60 * 60 * 24)))
  }

  const createdAt = user.created_at || user.date_creation
  if (createdAt) {
    const daysSince = (Date.now() - new Date(createdAt).getTime()) / (1000 * 60 * 60 * 24)
    return Math.max(0, Math.ceil(7 - daysSince))
  }

  return 0
}
